import {
  AutosuggestProps,
  NewsSearchItem
} from "@bluframe/mightychroma-mightytool-frontend-types"

import EditActions from "./EditActions"

export interface Props {
  isUpdateNewsEnabled: boolean
  label: string
  loading: boolean
  newsTitles: NewsSearchItem[]
  onClearAll: () => void
  onGetSuggestions: AutosuggestProps["onGetSuggestions"]

  onSelectNewsId: (id: string, name: string) => void
  onUpdateNews: () => void
  selectedNewsId: string
}

export interface ComponentProps extends Props {}

export default EditActions
